function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (e) {
  var r = {};

  function t(n) {
    if (r[n]) return r[n].exports;
    var i = r[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
  }

  return t.m = e, t.c = r, t.d = function (e, r, n) {
    t.o(e, r) || Object.defineProperty(e, r, {
      enumerable: !0,
      get: n
    });
  }, t.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, t.t = function (e, r) {
    if (1 & r && (e = t(e)), 8 & r) return e;
    if (4 & r && "object" == _typeof(e) && e && e.__esModule) return e;
    var n = Object.create(null);
    if (t.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & r && "string" != typeof e) for (var i in e) {
      t.d(n, i, function (r) {
        return e[r];
      }.bind(null, i));
    }
    return n;
  }, t.n = function (e) {
    var r = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return t.d(r, "a", r), r;
  }, t.o = function (e, r) {
    return Object.prototype.hasOwnProperty.call(e, r);
  }, t.p = "", t(t.s = 123);
}({
  0: function _(e, r) {
    e.exports = require("react");
  },
  1: function _(e, r, t) {
    e.exports = t(53)();
  },
  10: function _(e, r, t) {
    var n;
    !function () {
      "use strict";

      var t = {}.hasOwnProperty;

      function i() {
        for (var e = [], r = 0; r < arguments.length; r++) {
          var n = arguments[r];

          if (n) {
            var o = _typeof(n);

            if ("string" === o || "number" === o) e.push(n);else if (Array.isArray(n) && n.length) {
              var a = i.apply(null, n);
              a && e.push(a);
            } else if ("object" === o) for (var s in n) {
              t.call(n, s) && n[s] && e.push(s);
            }
          }
        }

        return e.join(" ");
      }

      void 0 !== e && e.exports ? (i.default = i, e.exports = i) : void 0 === (n = function () {
        return i;
      }.apply(r, [])) || (e.exports = n);
    }();
  },
  11: function _(e, r, t) {
    "use strict";

    Object.defineProperty(r, "__esModule", {
      value: !0
    });

    r.default = function (e, r, t) {
      var n = Object.keys(r),
          i = t && t.handleMissingStyleName || "throw";
      return e.split(" ").filter(function (e) {
        return e;
      }).map(function (e) {
        if (function (e) {
          return -1 !== e.indexOf(".");
        }(e)) return function (e, r, t) {
          var n = e.split("."),
              i = n[0],
              o = n[1],
              a = t || "throw";

          if (!o) {
            if ("throw" === a) throw new Error("Invalid style name: " + e);
            if ("warn" !== a) return null;
          }

          if (!r[i]) {
            if ("throw" === a) throw new Error("CSS module import does not exist: " + i);
            if ("warn" !== a) return null;
          }

          if (!r[i][o]) {
            if ("throw" === a) throw new Error("CSS module does not exist: " + o);
            if ("warn" !== a) return null;
          }

          return r[i][o];
        }(e, r, i);
        if (0 === n.length) throw new Error("Cannot use styleName attribute for style name '" + e + "' without importing at least one stylesheet.");
        if (n.length > 1) throw new Error("Cannot use anonymous style name '" + e + "' with more than one stylesheet import.");
        var t = r[n[0]];
        if (!t[e] && "throw" === i) throw new Error("Could not resolve the styleName '" + e + "'.");
        return t[e];
      }).filter(function (e) {
        return e;
      }).join(" ");
    };
  },
  123: function _(e, r, t) {
    "use strict";

    t.r(r), t.d(r, "Spinner", function () {
      return h;
    });

    var n = t(11),
        i = t.n(n),
        o = t(0),
        a = t.n(o),
        s = t(1),
        u = t.n(s),
        l = t(10),
        c = t.n(l),
        p = (t(296), Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];

        for (var n in t) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }),
        f = function () {
      function e(e, r) {
        for (var t = 0; t < r.length; t++) {
          var n = r[t];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      return function (r, t, n) {
        return t && e(r.prototype, t), n && e(r, n), r;
      };
    }(),
        _ = {
      "./styles.scss": {
        "c-spinner": "wri_api__c-spinner",
        rotate: "wri_api__rotate",
        dash: "wri_api__dash",
        color: "wri_api__color",
        "spinner-box": "wri_api__spinner-box",
        "spinner-icon": "wri_api__spinner-icon",
        "spinner-circle": "wri_api__spinner-circle",
        "-absolute": "wri_api__-absolute",
        "-fixed": "wri_api__-fixed",
        "-relative": "wri_api__-relative"
      }
    };

    function y(e, r, t) {
      return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[r] = t, e;
    }

    var b = {
      width: 40,
      height: 40
    },
        w = {
      fill: "none",
      stroke: "#000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
        h = function (e) {
      function r() {
        return function (e, r) {
          if (!(e instanceof r)) throw new TypeError("Cannot call a class as a function");
        }(this, r), function (e, r) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !r || "object" != _typeof(r) && "function" != typeof r ? e : r;
        }(this, (r.__proto__ || Object.getPrototypeOf(r)).apply(this, arguments));
      }

      return function (e, r) {
        if ("function" != typeof r && null !== r) throw new TypeError("Super expression must either be null or a function, not " + _typeof(r));
        e.prototype = Object.create(r && r.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(e, r) : e.__proto__ = r);
      }(r, o["PureComponent"]), f(r, [{
        key: "render",
        value: function value() {
          var e = this.props,
              r = e.position,
              t = e.customClass,
              n = e.style,
              o = c()(y({
            "c-spinner": !0
          }, "-" + r, !0)),
              s = c()(y({
            "c-spinner": !0
          }, t, !!t)),
              u = p({}, b, n.box),
              l = p({}, w, n.circle);
          return a.a.createElement("div", {
            className: (s ? s + " " : "") + i()(o, _)
          }, a.a.createElement("div", {
            className: "wri_api__spinner-box",
            style: u
          }, a.a.createElement("svg", {
            className: "wri_api__spinner-icon",
            viewBox: "25 25 50 50"
          }, a.a.createElement("circle", p({}, l, {
            className: "wri_api__spinner-circle",
            cx: 50,
            cy: 50,
            r: 20
          })))));
        }
      }]), r;
    }();

    h.propTypes = {
      position: u.a.oneOf(["relative", "absolute", "fixed"]),
      className: u.a.string,
      customClass: u.a.string,
      style: u.a.shape({
        box: u.a.object,
        circle: u.a.object
      })
    }, h.defaultProps = {
      position: "absolute",
      className: null,
      customClass: null,
      style: {
        box: {},
        circle: {}
      }
    }, r.default = h;
  },
  296: function _(e, r, t) {
    e.exports = {
      "c-spinner": "wri_api__c-spinner",
      "spinner-box": "wri_api__spinner-box",
      "spinner-icon": "wri_api__spinner-icon",
      rotate: "wri_api__rotate",
      "spinner-circle": "wri_api__spinner-circle",
      dash: "wri_api__dash",
      color: "wri_api__color",
      "-absolute": "wri_api__-absolute",
      "-fixed": "wri_api__-fixed",
      "-relative": "wri_api__-relative"
    };
  },
  53: function _(e, r, t) {
    "use strict";

    var n = t(54);

    function i() {}

    e.exports = function () {
      function e(e, r, t, i, o, a) {
        if (a !== n) {
          var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw s.name = "Invariant Violation", s;
        }
      }

      function r() {
        return e;
      }

      e.isRequired = e;
      var t = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: r,
        element: e,
        instanceOf: r,
        node: e,
        objectOf: r,
        oneOf: r,
        oneOfType: r,
        shape: r,
        exact: r
      };
      return t.checkPropTypes = i, t.PropTypes = t, t;
    };
  },
  54: function _(e, r, t) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }
});